import { updateBasketList } from 'containers/OrderDetails/basketSlice'
import { selectUser } from 'containers/Login/loginSlice'
import { initialExp, finalExp } from 'utils/validation'
import { useSelector, useDispatch } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { useState } from 'react'

const Form = ({ back, list }) => {
  const user = useSelector(selectUser)
  const [form, setForm] = useState({
    email: user.email || '',
    phone: user.phone || ''
  })

  const { email, phone } = form
  const isFormValid = phone.match(finalExp.phone) && email.match(finalExp.mail)

  const dispatch = useDispatch()
  const { t } = useTranslation('basket')

  const changeHandler = e => {
    if (!e) return
    const { name, value } = e.target

    if ((name === 'phone' ? value.match(initialExp.phone) : value.match(initialExp.mail))) setForm({
      ...form,
      [name]: value
    })
  }

  const notify = () => {
    dispatch(updateBasketList(list.reduce((r, { identifier }) => {
      r = {
        ...r,
        [identifier]: { notify: { phone, email } }
      }
      return r
    }, {})))
    back()
  }

  return (
    <div className='popup--newPlace popup__reservationFailed'>
      <p>
        <span>{t('notifications')}</span>
        <span>{t('completeToReceiveInfoAboutTheWarehouse')}</span>
      </p>

      <div className='popup__input'>
        {phone && <div className='input__label'>{t('phoneNumber')}</div>}
        <input
          value={phone}
          name='phone'
          type='tel'
          placeholder={t('phoneNumber')}
          onChange={changeHandler} />
      </div>

      <div className='popup__input'>
        {email && <div className='input__label'>{t('email')}</div>}
        <input
          value={email}
          name='email'
          placeholder={t('email')}
          onChange={changeHandler} />
      </div>

      <div className='popup__buttons center'>
        <div
          className='button__cancel --secFont'
          onClick={back}>
          {t('close')}
        </div>
        <div
          className='button__submit --secFont'
          style={isFormValid ? undefined : { opacity: 0.67 }}
          onClick={() => isFormValid && notify()}>
          {t('report')}
        </div>
      </div>
    </div>
  )
}

export default Form